import { render, staticRenderFns } from "./PlacePartInfo.vue?vue&type=template&id=50ede666&"
import script from "./PlacePartInfo.vue?vue&type=script&lang=js&"
export * from "./PlacePartInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports